module.exports = __webpack_public_path__ + "assets/ibm.34d38d4a.svg";